module.exports = __webpack_public_path__ + "static/img/Christmas2_content1_img2.66ed9a0.png";